<template>
  <v-container>
    <v-layout row class="text-xs-right">
      <v-flex xs6 class="indigo">
        <v-img :src="loginImage" height="600" position="center center" />
      </v-flex>
      <v-flex xs6>
        <v-container
          style="width: 450px; position: relative; top: 3%"
          class="text-xs-center"
        >
          <v-layout>
            <v-img
              :src="image"
              width="100px"
              position="center center"
              height="60"
              contain
            />
          </v-layout>
          <br />

          <v-text-field
            class="style-input"
            label="Email"
            prepend-icon="person"
            type="text"
            v-model="email"
            required
            :error="error"
            :append-icon="icon"
            :error-messages="messages"
            v-on:change="showText"
          />

          <p v-if="ldap" class="body">
            Your account is associated with your company Intranet Account <br />

            Please click Submit if you want to send the request to your Intranet
            administrator
          </p>
          <v-card-actions>
            <v-flex xs12 class="text-xs-center">
              <v-btn
                @click="resetPassword"
                v-if="this.email"
                color="indigo white--text"
                small
              >
                <strong> Reset </strong></v-btn
              >
            </v-flex>
            <v-flex v-if="done" class="text-xs-center">
              Your request has been sent! You will soon receive the username and
              password
            </v-flex>
          </v-card-actions>
          <br />
          <br />
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style></style>
<script>
import UserModel from "../../../api/service/UserService.js";

import EmailService from "@/api/service/EmailService";

export default {
  $_veeValidate: {
    validator: "new",
  },
  data: () => ({
    image: require("@/assets/tibura1.png"),
    loginImage: require("@/assets/reset-password1.jpg"),
    email: "",
    validUser: false,
    error: false,
    ldap: false,
    icon: "lock",
    messages: [],
    done: false,
  }),

  mounted() {},

  methods: {
    resetPassword() {
      UserModel.resetPassword({ email: this.email })
        .then(($response) => this.sendEmail())
        .catch(($error) => console.log($error));
    },
    sendEmail() {
      EmailService.password(this.email);
      this.done = true;
      setTimeout(this.loginPage, 3000);
    },
    loginPage() {
      this.$router.push("/logincompany");
    },
    showText() {
      this.ldap = false;
      UserModel.checkUser(this.email)
        .then(($response) => {
          if ($response.length == 0) {
            this.setValid(false);
          } else {
            this.setValid(true);
          }
        })
        .catch(($error) => this.setValid(false));
    },
    setValid($flag) {
      this.validUser = $flag;
      if (!$flag) {
        this.error = true;
        this.icon = "lock";
        this.messages.push("Invalid Email or Email is inactive");
        //this.error =""
      } else {
        this.icon = "fa fa-check";
        this.error = false;
        this.messages = [];
      }
    },
  },
};
</script>

<style scoped>
.style-input {
  padding: 0px;
  margin: 0px;
  width: 100%;
}
.style-input1 {
  background-color: yellow;
}
</style>
